const fd = {
    client_id: null,
    service_id: null,
    duration: null,
    final_price: null,
    dateOptions: {
        value: '',
        text: '',
    },
    date: null,
    days: [],
    source: 'admin-panel',
    executors: [],
    description: '',
    address: {
        country: 'Austria',
        city: 'Vienna',
        street: '',
        house: '',
    },
    my_hammer: '',
    office_id: '',
    status: 'stand_by',
}

const localState = {
    showModalAdd: false,
    showModalDelete: false,
    contact: {},
    description: '',
    formData: fd,
    deleteId: '',
    deletion_tag: false,

    notification: {
        show: false,
        id: null,
    },
}

const mutations = {
    toggleShowModalAdd: (state) => {
        state.showModalAdd = !state.showModalAdd
    },
    closeShowModalAdd: (state) => {
        state.showModalAdd = false
    },
    setShowModalAdd: (state, v) => {
        state.showModalAdd = v
    },
    toggleShowModalDelete: (state) => {
        state.showModalDelete = !state.showModalDelete
    },
    setContact: (state, v) => {
        state.contact = v
    },
    setDescription: (state, v) => {
        state.description = v
    },
    setFormData: (state, v) => {
        state.formData[v.key] = v.value
    },
    setDefaultForm: (state) => {
        state.formData = {
            client_id: null,
            service_id: null,
            duration: null,
            final_price: null,
            dateOptions: {
                value: '',
                text: '',
            },
            date: null,
            days: [],
            source: 'admin-panel',
            executors: [],
            description: '',
            address: {
                country: 'Austria',
                city: 'Vienna',
                street: '',
                house: '',
            },
            my_hammer: '',
            office_id: '',
            status: 'stand_by',
        }
    },
    setDeleteId: (state, v) => {
        state.deleteId = v
    },
    setVDeletionStatus: (state, v) => {
        state.deletion_tag = v
    },
    setNotification: (state, v) => {
        state.notification.show = v.show
        state.notification.id = v.id
    },
    cleatNotification: (state) => {
        state.notification.show = false
        state.notification.id = null
    },
}

const actions = {
    async remove({
        state,
    }) {
        return await this.$api.orders.removeRequest(state.deleteId)
    },
}

const getters = {
    showModalAdd: (state) => state.showModalAdd,
    contactGetter: (state) => state.contact,
    descriptionGetters: (state) => state.description,
    formDataGetters: (state) => state.formData,
    deleteIGetters: (state) => state.deleteId,
    showModalDelete: (state) => state.showModalDelete,
    deletionStatusGetters: (state) => state.deletion_tag,
    notificationShow: (state) => state.notification.show,
    notification: (state) => state.notification,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
